import {combineReducers} from 'redux';
import ACTION from '../action_constant';


function messages(
  state = {
  },
  action
){
  switch (action.type) {
    case ACTION.MESSAGES.MESSAGE_THREAD:
    {
        let shipperMessages;
        let carrierMessages;
        let receiverMessages;
        let isShipping = action.data.isShipping;
        let nextUrl = action.data.nextUrl;
        let messages = action.data.messages;

        if(action.data.messages){
          let stateMessages = state.messageList || [];
          let updatedMessageList = [...stateMessages,...messages];
          Object.assign(state, { messageList: updatedMessageList});
        }

        if(action.data.isShipping == 0){
          shipperMessages = {messages: action.data.messages, nextUrl: nextUrl};
          return Object.assign({}, state, { shipperMessages: shipperMessages,
                                            carryingCount: action.data.carryingCount,
                                            receivingCount: action.data.receivingCount,
                                            shippingCount: action.data.shippingCount
                                          });
        }

        else if(action.data.isShipping == 1){
          carrierMessages = {messages: action.data.messages, nextUrl: nextUrl};
          return Object.assign({}, state, { carrierMessages: carrierMessages,
                                            carryingCount: action.data.carryingCount,
                                            receivingCount: action.data.receivingCount,
                                            shippingCount: action.data.shippingCount
                                          });
        }

        else{
          receiverMessages = {messages: action.data.messages, nextUrl: nextUrl};
          return Object.assign({}, state, { receiverMessages: receiverMessages,
                                            carryingCount: action.data.carryingCount,
                                            receivingCount: action.data.receivingCount,
                                            shippingCount: action.data.shippingCount
                                          });
        }

     }

     case ACTION.MESSAGES.UPDATE_MESSAGE_THREAD: {
      //   for original messsages from state
           let shipperMessages;
           let carrierMessages;
           let receiverMessages;

      // for paginated messages from api response
           let paginatedShipperMessages;
           let paginatedCarrierMessages;
           let paginatedReceiverMessages;

      // new message including nextUrl that will be the next State
           let updatedShipperMesssage;
           let updatedCarrierMessages;
           let updatedReceiverMessages;

           let isShipping = action.data.isShipping;
           let messages = action.data.messages;
           let nextUrl = action.data.nextUrl;

           if(action.data.messages){
             let stateMessages = state.messageList || [];
             let updatedMessageList = [...stateMessages,...messages];
             Object.assign(state, { messageList: updatedMessageList});
           }

           if(action.data.isShipping == 0){

             // from api
             paginatedShipperMessages = action.data.messages;

             // from local state
             shipperMessages = Object.assign({}, state.shipperMessages);

             // merging both
             paginatedShipperMessages.forEach((message) => {
               shipperMessages.messages.push(message);
             })
             // creating new objects
             updatedShipperMesssage = {messages: shipperMessages.messages, nextUrl: nextUrl};

             return Object.assign({}, state, { shipperMessages: updatedShipperMesssage,
                                               carryingCount: action.data.carryingCount,
                                               receivingCount: action.data.receivingCount,
                                               shippingCount: action.data.shippingCount
                                             });
           }

           else if(action.data.isShipping == 1){
             // from api
             paginatedCarrierMessages = action.data.messages;
             // from local state
             carrierMessages = Object.assign({}, state.carrierMessages);
             // merging both
             paginatedCarrierMessages.forEach((message) => {
               carrierMessages.messages.push(message);
             })
             // creating new objects
             updatedCarrierMessages = {messages: carrierMessages.messages, nextUrl: nextUrl};

             return Object.assign({}, state, { carrierMessages: updatedCarrierMessages,
                                               carryingCount: action.data.carryingCount,
                                               receivingCount: action.data.receivingCount,
                                               shippingCount: action.data.shippingCount
                                             });
           }
           else {
             // from api
             paginatedReceiverMessages = action.data.messages;
              // from local state
             receiverMessages =  Object.assign({}, state.receiverMessages);
              // merging both
              paginatedReceiverMessages.forEach((message) => {
                receiverMessages.messages.push(message);
              })

              // creating new objects
              updatedReceiverMessages = {messages: receiverMessages.messages, nextUrl: nextUrl};

              return Object.assign({}, state, { receiverMessages: updatedReceiverMessages,
                                                carryingCount: action.data.carryingCount,
                                                receivingCount: action.data.receivingCount,
                                                shippingCount: action.data.shippingCount
                                              });
           }
     }


    default:
      return state;

  }
}

module.exports = messages;



// WEBPACK FOOTER //
// app/messages/messages_reducer.jsx